<template>
    <inquiry-form-field field-name="section">
        <inquiry-form-sections-select-field name="section" v-model="selected" :sections="sections" :priceBlockNote="perfBlockNotes" required />
    </inquiry-form-field>
</template>

<script>
export default {
    name: 'InquiryFormSections',
    props: { value: [Number, String], pricingTier: [Object, Boolean] },
    emits: ['update-section-details'],
    computed: {
        selected: {
            get() {
                return this.value
            },
            set(index) {
                this.$emit('input', index);
                this.$emit('update-section-details', this.pricingTier ? this.pricingTier.pricingChart[index] : null);
            }
        },
        perfBlockNotes() {
            if(this.pricingTier != null) return this.pricingTier.perfBlockNotes;
            else return '';
        },
        sections() {
            return this.pricingTier ? this.pricingTier.pricingChart : []
        }
    },
    methods: {
    },
};
</script>
